<template>
  <Fragment>
    <template v-if="$route.name === 'addNewProduct'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <div class="search-name mr-15">
              <span>品牌名称：</span>
              <el-input v-model="searchName"> </el-input>
            </div>
            <div class="search-code mr-15">
              <span>品牌编码：</span>
              <el-input v-model="searchCode"> </el-input>
            </div>
            <el-button type="primary" class="ml-20">查询</el-button>
          </div>

          <el-button type="primary" class="mr-20" @click="addBrand"
            >添加品牌</el-button
          >
        </section>
      </div>
      <el-table :data="list" style="width: 100%" border>
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            <span>{{ scope.$index + (currentPage - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="品牌名称" width="350">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="品牌编码">
          <template slot-scope="scope">
            <span>{{ scope.row.code }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.type }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template>
            <el-button size="mini">编辑</el-button>
            <el-button size="mini" type="danger">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="prev, pager, next, jumper"
        :total="total"
        :page-size="20"
        :current-page="currentPage"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";
export default {
  data() {
    return {
      searchName: "",
      searchCode: "",
      list: [],
      currentPage: 1,
      pageSize: 20,
      total: 0
    };
  },
  mounted() {},
  methods: {
    handleCurrentChange(value) {
      this.currentPage = value;
    },
    handlePrePage() {
      this.currentPage -= 1;
    },
    handleNextPage() {
      this.currentPage += 1;
    },
    addBrand() {
      this.$router.push("/afterSale/newProduct/add");
    }
  },
  components: {
    Breadcrumb,
    Fragment
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
